export * from './ErrorSentry';
export { default as Layout } from './Layout.vm';
export { default as FrontLayout } from './FrontLayout.vm';
export { default as DeleteModal } from './DeleteModal.vm';
export { default as Login } from './Login.vm';
export { default as MobileMenu } from './MobileMenu.vm';
export { default as CovidPolicy } from './CovidPolicy.vm';
export { default as Loader } from './Loader';
export * from './EventsCard';


// WEBPACK FOOTER //
// ./src/components/index.js